import { render, staticRenderFns } from "./International.vue?vue&type=template&id=1627ea82&scoped=true&"
import script from "./International.vue?vue&type=script&lang=js&"
export * from "./International.vue?vue&type=script&lang=js&"
import style1 from "./International.vue?vue&type=style&index=1&id=1627ea82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1627ea82",
  null
  
)

export default component.exports